import { NgIf } from '@angular/common';
import {
  Component,
  EventEmitter,
  Input,
  Output,
  QueryList,
  ViewChildren,
  ViewEncapsulation
} from '@angular/core';
import { GeneralModalComponent } from '@com-delta-omnichannel/mach';
import { BookWidgetFieldInfoModal } from '../../../models/book-widget-aem.interfaces';
import { INFO_POPUP_MODAL_ID } from './models/info-popup-modal.constants';

@Component({
  selector: 'idp-info-popup-modal',
  standalone: true,
  imports: [NgIf, GeneralModalComponent],
  templateUrl: './info-popup-modal.component.html',
  styleUrls: ['./info-popup-modal.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class InfoPopUpModalComponent {
  @ViewChildren(GeneralModalComponent)
  modals!: QueryList<GeneralModalComponent>;

  @Input() content!: BookWidgetFieldInfoModal;

  @Output() exit: EventEmitter<void> = new EventEmitter<void>();
  id = INFO_POPUP_MODAL_ID;

  closeModal(exit: boolean): void {
    const modal = this.modals.find((modal) => modal.id === this.id);
    modal?.close(this.id);
    if (exit) {
      this.exit.emit();
    }
  }

  openModal(): void {
    const modal = this.modals.find((modal) => modal.id === this.id);
    modal?.open(this.id);
  }

  onClose(isClosed: boolean) {
    if (isClosed) {
      this.exit.emit();
    }
  }
}
